/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

interface ReminderMessageProps {
  reminderMessage: string;
  assigneeDetails: { userId: string; name: string }[];
  isReminderDismissed?: boolean;
}

const ReminderMessage = ({ reminderMessage, assigneeDetails, isReminderDismissed }: ReminderMessageProps) => {
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;

  for (const match of reminderMessage.matchAll(/@\[\{([^}]+)\}\]/g)) {
    const matchStart = match.index!;
    const matchEnd = matchStart + match[0].length;
    const userId = match[1];
    const username = (assigneeDetails || []).find((user) => user.userId === userId)?.name;

    if (lastIndex < matchStart) {
      parts.push(reminderMessage.slice(lastIndex, matchStart));
    }

    parts.push(
      <span
        key={matchStart}
        css={css`
          color: ${isReminderDismissed ? '#7a7a7a' : '#3f906d'};
          font-weight: ${isReminderDismissed ? 400 : 500};
        `}
      >
        @{username}
      </span>
    );

    lastIndex = matchEnd;
  }

  if (lastIndex < reminderMessage.length) {
    parts.push(reminderMessage.slice(lastIndex));
  }

  return <>{parts}</>;
};

export default ReminderMessage;
